var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import PropTypes from 'prop-types';

var CardContent = function (_React$Component) {
  _inherits(CardContent, _React$Component);

  function CardContent() {
    _classCallCheck(this, CardContent);

    return _possibleConstructorReturn(this, (CardContent.__proto__ || Object.getPrototypeOf(CardContent)).apply(this, arguments));
  }

  _createClass(CardContent, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'cf-card__content' },
        React.createElement(
          'h3',
          { className: 'cf-card__title' },
          this.props.title
        ),
        this.props.children,
        this.props.footerMessage ? React.createElement(
          'div',
          { className: 'cf-card__footer_message' },
          this.props.footerMessage
        ) : null
      );
    }
  }]);

  return CardContent;
}(React.Component);

CardContent.propTypes = {
  title: PropTypes.any.isRequired,
  footerMessage: PropTypes.string,
  children: PropTypes.node
};

export default CardContent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-card/es/CardContent.js
// module id = 612
// module chunks = 0